/**
 * PublicLayout.tsx — shell for public (unauthenticated) pages.
 * Landing, Login, Signup all render inside this wrapper.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';

export function PublicLayout() {
  return (
    <div className="mer-full-page" style={{
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Outlet />
    </div>
  );
}
